// extracted by mini-css-extract-plugin
export default {"wrapper":"AppBar_wrapper__EWxjt","section":"AppBar_section__zXNsI","title":"AppBar_title__osxYZ"};